import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { VoucherCreatePageRoutingModule } from './voucher-create-routing.module';

import { VoucherCreatePage } from './voucher-create.page';
import { IonicSelectableModule } from 'ionic-selectable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    VoucherCreatePageRoutingModule,
    IonicSelectableModule
  ],
  declarations: [VoucherCreatePage]
})
export class VoucherCreatePageModule {}
